import { useCurrentTripContext } from '../hooks/useCurrentTripContext'
import { useAuthContext } from '../hooks/useAuthContext'

const TripFlights = ({trip, flights, onAddFlight, onEditFlight}) => {
    const { dispatch } = useCurrentTripContext()
    const { user } = useAuthContext()


    const handleClick = async (e, flight) => {
        e.preventDefault()
        e.stopPropagation()
        if (!user) {
            return
        }
        
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/flight/`, {
            method: 'DELETE',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({trip_id: trip._id, flight_id: flight._id}),
            credentials: 'include'
        })
        const json = await response.json()
        if (response.ok) {
            dispatch({type: 'DELETE_FLIGHT', payload: json})
        }
    }

    return (
        <div className="flights-page">
            <h3>Flights:</h3>
            <button onClick={() => onAddFlight("add")}>Add Flight</button>
            <div className="flights-list">
                {flights?.map((flight) => (
                    <div key={flight._id} className="flight-card" onClick={(e) => {
                        onEditFlight(flight)
                        onAddFlight("edit")
                        }}>
                        <p><strong>{flight.departure_airport} ({flight.departure_airport_code})</strong> to <strong>{flight.arrival_airport} ({flight.arrival_airport_code})</strong></p>
                        <div className="flight-information">
                            <div className="depart-arrival-details">
                                <p>Depart: {flight.departure_date} at {flight.departure_time}</p>
                                <p>Arrive: {flight.arrival_date} at {flight.arrival_time}</p>
                            </div>
                            <div className="flight-seat-number">
                                <p>Flight Number: {flight.flight_number}</p>
                                <p>Seat Number: {flight.seat_number}</p>
                            </div>
                        </div>
                        <p>Additional notes: {flight.additional_notes}</p>
                        <span className="material-symbols-outlined" onClick={(e) => {handleClick(e, flight)}}>delete</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TripFlights

